import {
  AppBar,
  Box,
  Button,
  debounce,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  ListItem,
  ListItemText,
  MenuItem,
  Paper,
  Select,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import { Transition } from "../../../../../../../../components";
import { useListaCidadesService } from "../../../../../../../../../use-cases/geo-veles";
import { useAppSelector } from "../../../../../../../../hooks/store-hooks";
import { useState } from "react";
import { FixedSizeList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
// Icons
import FileIcon from "@mui/icons-material/FileUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import { ListaCidadesImportFile } from "./ListaCidadeImportFile";
import { EditCidade } from "./EditCidade";
import { Download } from "@mui/icons-material";

export const EditListaCidadesForm = (props: { openForm: boolean }) => {
  // State
  const { listaCidades } = useAppSelector((state) => state);
  // Use State
  const [addCidadeValue, setAddCidadeValue] = useState<string>("");
  const [cidadeSearchTerm, setCidadeSearchTerm] = useState<string>("");
  const [oldCidade, setOldCidade] = useState<string>("");

  // 👇 Novos estados para o diálogo de confirmação
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState<boolean>(false);
  const [cidadeToDelete, setCidadeToDelete] = useState<string>("");

  // Hook
  const {
    closeEditListaCidadesForm,
    setEditListaCidadesName,
    updateListaCidades,
    listaCidadesRemoveCidade,
    openImportFileListaCidades,
    setupListaCidades,
    setAddCidade,
    setSelectUf,
    setAddCidadeUnitaria
  } = useListaCidadesService();

  // Função para abrir o diálogo de confirmação
  const handleOpenConfirmDelete = (cidade: string) => {
    setCidadeToDelete(cidade);
    setConfirmDeleteOpen(true);
  };

  // Função para confirmar a exclusão
  const handleConfirmDelete = () => {
    listaCidadesRemoveCidade(cidadeToDelete);
    setConfirmDeleteOpen(false);
    setCidadeToDelete("");
  };

  // Função para cancelar a exclusão
  const handleCancelDelete = () => {
    setConfirmDeleteOpen(false);
    setCidadeToDelete("");
  };

  return (
    <>
      {props.openForm === true && (
        <>
          <Dialog
            fullScreen
            open={listaCidades.openEditListaCidades}
            TransitionComponent={Transition}
            onClose={() => {
              closeEditListaCidadesForm();
              setupListaCidades();
            }}
          >
            <AppBar sx={{ position: "relative" }}>
              <Toolbar>
                <Typography
                  sx={{ ml: 2, flex: 1 }}
                  textTransform="uppercase"
                  variant="h6"
                  component="div"
                >
                  Editar lista - {listaCidades.editListaCidadesForm.fields.nome}
                </Typography>
                <Button
                  autoFocus
                  color="inherit"
                  onClick={() => {
                    closeEditListaCidadesForm();
                    setupListaCidades();
                  }}
                >
                  Fechar
                </Button>
              </Toolbar>
            </AppBar>
            <Box p={3}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Nome da lista"
                    placeholder="Digite o nome da lista"
                    defaultValue={listaCidades.editListaCidadesForm.fields.nome}
                    onChange={debounce((e) => {
                      setEditListaCidadesName(e.target.value);
                    }, 500)}
                  />

                  <Button
                    startIcon={<Download />}
                    color="primary"
                    fullWidth
                    variant="contained"
                    sx={{
                      mt: 2,
                      textTransform: "uppercase",
                      textDecoration: "none",
                      color: "white",
                      "&:hover": {
                        color: "white",
                        textDecoration: "none",
                      },
                    }}
                    component="a"
                    href="/Modelo_Cidades.xlsx"
                    download="Planilha_Modelo_Cidades.xlsx"
                  >
                    Baixar Modelo de planilha
                  </Button>
                </Grid>

                <Grid item xs={12}>
                  <Paper elevation={3}>
                    <Box p={3}>
                      <Grid container spacing={3}>
                        <Grid item xs={12}>
                          <Typography
                            variant="h6"
                            fontWeight="bold"
                            textTransform="uppercase"
                            color="primary"
                          >
                            Adicionar Cidade Unitária
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Grid container spacing={2}>
                            <Grid item xs={8}>
                              <TextField
                                fullWidth
                                label="Digite o nome da cidade que deseja adicionar"
                                value={listaCidades.editListaCidadesForm.fields.cidadeUnitaria}
                                onChange={(e) => {
                                  setAddCidade(e.target.value);
                                }}
                              />
                            </Grid>
                            <Grid item xs={2}>
                              <FormControl fullWidth>
                                <InputLabel>Escolha o estado</InputLabel>
                                <Select
                                  value={listaCidades.editListaCidadesForm.fields.estadoUnitario}
                                  onChange={(e) => {
                                    setSelectUf(e.target.value);
                                  }}
                                  label="Escolha o estado"
                                >
                                  <MenuItem value="AC">Acre</MenuItem>
                                  <MenuItem value="AL">Alagoas</MenuItem>
                                  <MenuItem value="AP">Amapá</MenuItem>
                                  <MenuItem value="AM">Amazonas</MenuItem>
                                  <MenuItem value="BA">Bahia</MenuItem>
                                  <MenuItem value="CE">Ceará</MenuItem>
                                  <MenuItem value="DF">Distrito Federal</MenuItem>
                                  <MenuItem value="ES">Espírito Santo</MenuItem>
                                  <MenuItem value="GO">Goiás</MenuItem>
                                  <MenuItem value="MA">Maranhão</MenuItem>
                                  <MenuItem value="MT">Mato Grosso</MenuItem>
                                  <MenuItem value="MS">Mato Grosso do Sul</MenuItem>
                                  <MenuItem value="MG">Minas Gerais</MenuItem>
                                  <MenuItem value="PA">Pará</MenuItem>
                                  <MenuItem value="PB">Paraíba</MenuItem>
                                  <MenuItem value="PR">Paraná</MenuItem>
                                  <MenuItem value="PE">Pernambuco</MenuItem>
                                  <MenuItem value="PI">Piauí</MenuItem>
                                  <MenuItem value="RJ">Rio de Janeiro</MenuItem>
                                  <MenuItem value="RN">Rio Grande do Norte</MenuItem>
                                  <MenuItem value="RS">Rio Grande do Sul</MenuItem>
                                  <MenuItem value="RO">Rondônia</MenuItem>
                                  <MenuItem value="RR">Roraima</MenuItem>
                                  <MenuItem value="SC">Santa Catarina</MenuItem>
                                  <MenuItem value="SP">São Paulo</MenuItem>
                                  <MenuItem value="SE">Sergipe</MenuItem>
                                  <MenuItem value="TO">Tocantins</MenuItem>
                                  {/* 
                                  <MenuItem value="AC">AC</MenuItem>
                                  <MenuItem value="AL">AL</MenuItem>
                                  <MenuItem value="AP">AP</MenuItem>
                                  <MenuItem value="AM">AM</MenuItem>
                                  <MenuItem value="BA">BA</MenuItem>
                                  <MenuItem value="CE">CE</MenuItem>
                                  <MenuItem value="DF">DF</MenuItem>
                                  <MenuItem value="ES">ES</MenuItem>
                                  <MenuItem value="GO">GO</MenuItem>
                                  <MenuItem value="MA">MA</MenuItem>
                                  <MenuItem value="MT">MT</MenuItem>
                                  <MenuItem value="MS">MS</MenuItem>
                                  <MenuItem value="MG">MG</MenuItem>
                                  <MenuItem value="PA">PA</MenuItem>
                                  <MenuItem value="PB">PB</MenuItem>
                                  <MenuItem value="PR">PR</MenuItem>
                                  <MenuItem value="PE">PE</MenuItem>
                                  <MenuItem value="PI">PI</MenuItem>
                                  <MenuItem value="RJ">RJ</MenuItem>
                                  <MenuItem value="RN">RN</MenuItem>
                                  <MenuItem value="RS">RS</MenuItem>
                                  <MenuItem value="RO">RO</MenuItem>
                                  <MenuItem value="RR">RR</MenuItem>
                                  <MenuItem value="SC">SC</MenuItem>
                                  <MenuItem value="SP">SP</MenuItem>
                                  <MenuItem value="SE">SE</MenuItem>
                                  <MenuItem value="TO">TO</MenuItem> */}
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={2}>
                              <Button
                                fullWidth
                                type="submit"
                                variant="contained"
                                disabled={
                                  listaCidades.editListaCidadesForm.fields.cidadeUnitaria === ""
                                  || listaCidades.editListaCidadesForm.fields.estadoUnitario === ""
                                }
                                onClick={() => {
                                  setAddCidadeUnitaria({
                                    cidade: listaCidades.editListaCidadesForm.fields.cidadeUnitaria ?? "",
                                    uf: listaCidades.editListaCidadesForm.fields.estadoUnitario ?? "",

                                  });
                                }}
                                sx={{ height: "56px" }}
                              >
                                Adicionar
                              </Button>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography
                            variant="h6"
                            fontWeight="bold"
                            textTransform="uppercase"
                            align="center"
                            color="primary"
                          >
                            OU
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  </Paper>
                </Grid>
                <Grid item xs={12}>
                  <Paper elevation={3}>
                    <Box p={3}>
                      <Grid container spacing={3}>
                        <Grid item xs={12}>
                          <Typography
                            variant="h6"
                            fontWeight="bold"
                            textTransform="uppercase"
                            color="primary"
                          >
                            Adicionar Lista de Cidades
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <Button
                              startIcon={<FileIcon />}
                              variant="contained"
                              onClick={(e) => {
                                e.preventDefault();
                                openImportFileListaCidades(true);
                              }}
                            >
                              Clique aqui para Importar arquivo
                            </Button>
                          </div>
                        </Grid>
                      </Grid>
                    </Box>
                  </Paper>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Pesquisar Cidade"
                    placeholder="Digite a cidade que deseja pesquisar"
                    fullWidth
                    value={cidadeSearchTerm}
                    onChange={(e) => {
                      setCidadeSearchTerm(e.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography color="primary" variant="h6">
                    Tamanho:{" "}
                    {(Array.isArray(
                      listaCidades.editListaCidadesForm.fields.cidades,
                    )
                      ? listaCidades.editListaCidadesForm.fields.cidades.length
                      : 0
                    ).toLocaleString("pt-Br")}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  height={
                    (listaCidades.editListaCidadesForm.fields.cidades.length ??
                      0) <= 3
                      ? 175
                      : 250
                  }
                  maxHeight={400}
                >
                  <AutoSizer>
                    {(data: any) => (
                      <FixedSizeList
                        height={
                          (listaCidades.editListaCidadesForm.fields.cidades
                            .length ?? 0) <= 3
                            ? 175
                            : 250
                        }
                        style={{
                          maxHeight: 400,
                        }}
                        width={data.width}
                        itemSize={46}
                        itemCount={
                          (Array.isArray(
                            listaCidades.editListaCidadesForm.fields.cidades,
                          )
                            ? listaCidades.editListaCidadesForm.fields.cidades
                            : []
                          ).filter((cidade) => {
                            if (
                              cidadeSearchTerm === "" ||
                              cidadeSearchTerm === undefined ||
                              cidade
                                .toLowerCase()
                                .includes(cidadeSearchTerm.toLowerCase())
                            ) {
                              return true;
                            } else {
                              return false;
                            }
                          }).length ?? 0
                        }
                        overscanCount={15}
                      >
                        {({ index, style }) => {
                          const item = (
                            Array.isArray(
                              listaCidades.editListaCidadesForm.fields.cidades,
                            )
                              ? listaCidades.editListaCidadesForm.fields.cidades
                              : []
                          ).filter((cidade) => {
                            if (
                              cidadeSearchTerm === "" ||
                              cidadeSearchTerm === undefined ||
                              cidade
                                .toLowerCase()
                                .includes(cidadeSearchTerm.toLowerCase())
                            ) {
                              return true;
                            } else {
                              return false;
                            }
                          })[index];
                          return (
                            <ListItem
                              style={style}
                              secondaryAction={
                                <>
                                  <Button
                                    onClick={() => {
                                      handleOpenConfirmDelete(item);
                                    }}
                                    startIcon={<DeleteIcon />}
                                  >
                                    Excluir
                                  </Button>
                                </>
                              }
                            >
                              <ListItemText primary={item} />
                            </ListItem>
                          );
                        }}
                      </FixedSizeList>
                    )}
                  </AutoSizer>
                </Grid>
                <Grid item xs={12}>
                  <Button
                    fullWidth
                    onClick={(e) => {
                      e.stopPropagation();
                      updateListaCidades();
                    }}
                    variant="contained"
                  >
                    Salvar alterações
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Dialog>

          {/* Diálogo de confirmação de exclusão */}
          <Dialog
            open={confirmDeleteOpen}
            onClose={handleCancelDelete}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"Confirmar exclusão"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Tem certeza que deseja excluir a cidade{" "}
                <strong>{cidadeToDelete}</strong>?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCancelDelete} color="primary">
                Cancelar
              </Button>
              <Button
                onClick={handleConfirmDelete}
                color="error"
                autoFocus
                variant="contained"
              >
                Excluir
              </Button>
            </DialogActions>
          </Dialog>

          <ListaCidadesImportFile
            openImportFile={listaCidades.openImportFileListaCidades}
          />
          <EditCidade
            openEditCidade={listaCidades.openEditCidades}
            oldCidade={oldCidade}
          />
        </>
      )}
    </>
  );
};
